module.exports = __webpack_public_path__ + "img/anniversary.78f14530.png";